import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatTableModule } from '@angular/material/table';
import { TimeSeriesPivotTableDataService } from '@backoffice-frontend/controlling/domain';
import { map, switchMap } from 'rxjs';
import { PivotTableService } from '../../data/pivot-table.service';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'feature-pivot-table-cell-history',
  imports: [CommonModule, MatTableModule, TranslocoPipe],
  templateUrl: './cell-history.component.html',
  styleUrls: ['./cell-history.component.scss'],
})
export class CellHistoryComponent {

  protected service = inject(TimeSeriesPivotTableDataService);
  protected pivotTableSerivce = inject(PivotTableService)

  dataSource$ = this.pivotTableSerivce.idColumnNameObservable.pipe(
    switchMap((data) =>
      this.service.getTimeSeriesHistory$(data.timeSeriesId, data.columnName),
    ),
    map((data) => data.items),
  );


  displayedColumns = ['oldValue', 'newValue', 'updatedBy', 'updatedDate'];
}
